import Content from "../../help/inventory-home.mdx";

export function InventoryHomeHelpPage() {
  return <Content />;
}
